import Vue from 'vue'
import Router from 'vue-router'

//解决同一个路由报错
// 获取原型对象push函数
const originalPush = Router.prototype.push
// 获取原型对象replace函数
const originalReplace = Router.prototype.replace
// 修改原型对象中的push函数
Router.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}
// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}

Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // 如果页面有savedPosition，即之前保存了滚动位置，则恢复
    if (savedPosition) {
      return savedPosition
    } else {
      // 如果没有保存位置，则返回顶部
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/ldcoin',
      component: () => import('@/views/ldcoin/index')
    },
    // {
    //   path: '/reg',
    //   component: () => import('@/views/ldcoin/reg')
    // },
    // {
    //   path: '/ldcoinlogin',
    //   component: () => import('@/views/ldcoin/login')
    // },
    // {
    //   path: '/selectAmount',
    //   component: () => import('@/views/ldcoin/selectAmount')
    // },
    // {
    //   path: '/user',
    //   component: () => import('@/views/ldcoin/user')
    // },
    // {
    //   path: '/userAgreement',
    //   component: () => import('@/views/ldcoin/userAgreement')
    // },
    // {
    //   path: '/ldcoinforgetPwd',
    //   component: () => import('@/views/ldcoin/forgetPwd')
    // },
    {
      path: '/index',
      component: () => import('@/views/index')
    },
    {
      path: '/info',
      component: () => import('@/views/info/info')
    },
    {
      path: '/username',
      component: () => import('@/views/info/username')
    },
    {
      path: '/mobile',
      component: () => import('@/views/info/mobile')
    },
    {
      path: '/email',
      component: () => import('@/views/info/email')
    },
    {
      path: '/currency',//贷币
      component: () => import('@/views/currency')
    },
    // {
    //   path: '/repayment',//还款详情
    //   component: () => import('@/views/repayment')
    // },
    {
      path: '/repayment2',//还款详情
      component: () => import('@/views/repayment2')
    },
    {
      path: '/repaymentNew',//还款详情页面
      component: () => import('@/views/repaymentNew')
    },
    {
      path: '/currencyRecord',
      component: () => import('@/views/currencyRecord')
    },
    {
      path: '/subscription',//新币申购
      component: () => import('@/views/subscription')
    },
    {
      path: '/subscriptionRecord',
      component: () => import('@/views/subscriptionRecord')
    },
    {
      path: '/subscriptionBuy',
      component: () => import('@/views/subscriptionBuy')
    },
    // {
    //   path: '/subscribe',//新币申购
    //   component: () => import('@/views/subscribe')
    // },
    {
      path: '/login',
      component: () => import('@/views/login'),
      // meta: {
      //   savePosition: true
      // }
    },
    {
      path: '/register',
      component: () => import('@/views/register'),
      meta: {
        requireAuth: false,
        keepAlive: true,
      }
    },
    // {
    //   path: '/text',//隐私条款
    //   component: () => import('@/views/text')
    // },
    {
      path: '/bannerDetail',//首页轮播详情
      component: () => import('@/views/bannerDetail')
    },
    {
      path: '/agrt',//用户协议
      component: () => import('@/views/agrt')
    },
    {
      path: '/agreement',//申请贷币协议
      component: () => import('@/views/agreement')
    },
    // {
    //   path: '/about',//旧版哦关于我们tab
    //   component: () => import('@/views/about')
    // },
    // {
    //   path: '/help',//旧版哦关于我们tab
    //   title: '帮助中心列表',
    //   component: () => import('@/views/help')
    // },
    {
      path: '/helpDetail',
      title: 'helpDetail',
      component: () => import('@/views/helpDetail')
    },
    {
      path: '/forgetpwd',
      title: 'forgetpwd',
      component: () => import('@/views/forgetpwd')
    },
    {
      path: '/market',
      title: '行情',
      component: () => import('@/views/market')
    },
    // {
    //   path: '/bindmpwd',
    //   title: '设置交易密码',
    //   component: () => import('@/views/bindmpwd')
    // },
    // {
    //   path: '/bindphone',
    //   title: '绑定手机号码',
    //   component: () => import('@/views/bindphone')
    // },
    // {
    //   path: '/deal',
    //   title: '币币交易',
    //   component: () => import('@/views/deal/index')
    // },
    // {
    //   path: '/deal_c',
    //   title: '合约交易',
    //   component: () => import('@/views/deal/deal_c')
    // },
    // {
    //   path: '/deal_jg',
    //   title: '交割合约',
    //   component: () => import('@/views/deal/deal_jg')
    // },
    // {
    //   path: '/lt',
    //   title: '合约持仓',
    //   component: () => import('@/views/deal/leverTransactions')
    // },
    // {
    //   path: '/jgcc',
    //   title: '交割持仓',
    //   component: () => import('@/views/deal/jgcc')
    // },
    // {
    //   path: '/all',
    //   title: '全部',
    //   component: () => import('@/views/deal/allDeal')
    // },
    // {
    //   path: '/dealList',
    //   title: '交易记录',
    //   component: () => import('@/views/deal/leverList')
    // },
    {
      path: '/notice',
      title: '公告中心',
      component: () => import('@/views/notice')
    },
    {
      path: '/profit_index',//AI量化；暂时不用；用vip_index
      title: '搬砖获利',
      component: () => import('@/views/profit/profit_index')
    },
    {
      path: '/profit_wdtg',
      title: '我的托管',
      component: () => import('@/views/profit/profit_wdtg')
    },
    {
      path: '/profit_buy',
      title: 'vip购买',
      name: 'profit_buy',
      component: () => import('@/views/profit/profit_buy')
    },
    {
      path: '/vip_index',
      title: 'vip理财',
      component: () => import('@/views/profit/vip_index')
    },
    {
      path: '/vip_wdtg',
      title: 'vip订单',
      component: () => import('@/views/profit/vip_wdtg')
    },
    {
      path: '/etflow_buy',
      title: '低风险下单',
      name: 'etflow_buy',
      component: () => import('@/views/profit/etflow_buy')
    },
    {
      path: '/etf_wdtg',
      title: '稳健型etf订单',
      component: () => import('@/views/profit/etf_wdtg')
    },
    {
      path: '/etflow_wdtg',
      title: '低风险etf订单',
      component: () => import('@/views/profit/etflow_wdtg')
    },
    // {
    //   path: '/downLoad',
    //   title: '下载',
    //   component: () => import('@/views/downLoad')
    // },
    // {
    //   path: '/recharge',
    //   title: '充币',
    //   component: () => import('@/views/recharge')
    // },
    // {
    //   path: '/money',
    //   title: '提币',
    //   component: () => import('@/views/money')
    // },
    // {
    //   path: '/view',
    //   title: 'view',
    //   component: () => import('@/views/deal/view')
    // },
    {
      path: '/asset',
      redirect: '/table1',
      component: () => import('@/views/asset/index'),
      children: [
        {
          path: '/table1',
          component: () => import('@/views/asset/asset-table1')
        },
        {
          path: '/table2',
          component: () => import('@/views/asset/asset-table2')
        },
        {
          path: '/record',
          title: '记录',
          component: () => import('@/views/asset/asset-record')
        },
        {
          path: '/transfer',
          title: '划转',
          component: () => import('@/views/asset/asset-transfer')
        },
        // {
        //   path: '/recharge',
        //   title: '充币',
        //   component: () => import('@/views/asset/asset-recharge')
        // },
        // {
        //   path: '/money',
        //   title: '提币',
        //   component: () => import('@/views/asset/asset-money')
        // },
        {
          path: '/address',
          title: '提币地址管理',
          component: () => import('@/views/asset/asset-address')
        }
      ]
    },
    {
      path: '/authentication',
      title: '初级认证',
      component: () => import('@/views/account/authentication')
    },
    {
      path: '/authenticationhigh',
      title: '高级认证',
      component: () => import('@/views/account/authenticationhigh')
    },
    {
      path: '/authenticationrj',
      title: '入金',
      component: () => import('@/views/account/authenticationrj')
    },
    {
      path: '/authenticationcj',
      title: '出金',
      component: () => import('@/views/account/authenticationcj')
    },
    {
      path: '/fengxian',
      title: '风险评估',
      component: () => import('@/views/account/fengxian')
    },
    {
      path: '/xinyongfen',
      title: '信用分',
      component: () => import('@/views/account/xinyongfen')
    },
    {
      path: '/wallet',
      title: '钱包管理',
      component: () => import('@/views/account/wallet')
    },
    {
      path: '/walletAdd',
      title: '添加钱包',
      component: () => import('@/views/account/walletAdd')
    },
    {
      path: '/bank',
      title: '银行卡管理',
      component: () => import('@/views/account/bank')
    },
    {
      path: '/bankAdd',
      title: '绑定银行卡',
      component: () => import('@/views/account/bankAdd')
    },
    // {
    //   path: '/authenticationgylx',
    //   title: '隔夜利息',
    //   component: () => import('@/views/account/authenticationgylx')
    // },
    // {
    //   path: '/authenticationxyf',
    //   title: '信用分',
    //   component: () => import('@/views/account/authenticationxyf')
    // },
    // {
    //   path: '/addcard',
    //   title: '添加银行卡',
    //   component: () => import('@/views/account/addcard')
    // },
    {
      path: '/addcardRecord',
      title: '提现记录',
      component: () => import('@/views/account/addcard-record')
    },
    // {
    //   path: '/account',
    //   title: '账户',
    //   component: () => import('@/views/account/index')
    //  },
      // {
      //   path: '/recharge',
      //   title: '充币',
      //   component: () => import('@/views/account/recharge')
      // },
      {
        path: '/rechargeRecord',
        title: '充币记录',
        component: () => import('@/views/account/recharge-record')
      },
      // {
      //   path: '/money',
      //   title: '提币',
      //   component: () => import('@/views/account/money')
      // },
      {
        path: '/moneyRecord',
        title: '提币记录',
        component: () => import('@/views/account/money-record')
      },
      {
        path: '/accountRecord',
        title: '账户记录',
        component: () => import('@/views/account/account-record')
      },
      {
        path: '/exchange',
        title: '兑换',
        component: () => import('@/views/account/exchange')
      },
      {
        path: '/service',
        title: '联系我们',
        component: () => import('@/views/account/service')
      },
      // {
      //   path: '/welfare',
      //   title: '福利专区',
      //   component: () => import('@/views/account/welfare')
      // },
      // {
      //   path: '/welfareDetail',
      //   title: '福利专区详情',
      //   component: () => import('@/views/account/welfare-detail')
      // },
      // {
      //   path: '/setting',
      //   title: '设置',
      //   component: () => import('@/views/account/setting')
      // },
      {
        path: '/settingNew',
        title: '新闻快讯',
        component: () => import('@/views/account/setting-new')
      },
      {
        path: '/setting-newdetail',
        title: '新闻',
        component: () => import('@/views/account/setting-newdetail')
      },
      {
        path: '/settingHelp',
        title: '帮助中心',
        component: () => import('@/views/account/setting-help')
      },
      {
        path: '/settingHelpdetail',
        title: '帮助中心',
        component: () => import('@/views/account/setting-helpdetail')
      },
      {
        path: '/settingAbout',
        title: '关于我们',
        component: () => import('@/views/account/setting-about')
      },
      {
        path: '/invite',
        title: '邀请好友',
        component: () => import('@/views/account/invite')
      },
      // {
      //   path: '/inviteList',
      //   title: '奖励列表',
      //   component: () => import('@/views/account/invite-list')
      // },
      // {
      //   path: '/inviteMy',
      //   title: '我的邀请',
      //   component: () => import('@/views/account/invite-my')
      // },
      {
        path: '/asset',
        title: '资产',
        component: () => import('@/views/account/asset')
      },
      {
        path: '/editPassword',
        title: '修改密码',
        component: () => import('@/views/account/editpassword')
      },
      {
        path: '/googleCode',
        title: '谷歌验证码',
        component: () => import('@/views/account/googleCode')
      },
    {
      path: '/editPasswordTrade',
      title: '交易密码',
      component: () => import('@/views/account/editpassword-trade')
    },
    {
      path: '/c2c_index',
      title: 'c2c',
      component: () => import('@/views/c2c/c2c_index')
    },
    {
      path: '/c2c_create',
      title: '创建订单',
      component: () => import('@/views/c2c/c2c_create')
    },
    {
      path: '/c2c_order',
      title: '查看订单',
      component: () => import('@/views/c2c/c2c_order')
    },
    {
      path: '/c2c_submit',
      title: '提交订单',
      component: () => import('@/views/c2c/c2c_submit')
    },
    {
      path: '/c2c_account',
      title: '查看汇款账号',
      component: () => import('@/views/c2c/c2c_account')
    },
    {
      path: '/c2c_rule',
      title: 'c2c规则',
      component: () => import('@/views/c2c/c2c_rule')
    },
    // {
    //   path: '/sign',//签到
    //   component: () => import('@/views/sign')
    // },
    // {
    //   path: '/signRule',//签到记录
    //   component: () => import('@/views/signRule')
    // },
    // {
    //   path: '/benefits',//福利专区
    //   component: () => import('@/views/benefits')
    // },
    // {
    //   path: '/benefitsDetail',
    //   component: () => import('@/views/benefitsDetail')
    // },
    // {
    //   path: '/preciousMetal',
    //   title: 'preciousMetal',
    //   component: () => import('@/views/preciousMetal/contractTransaction')
    // },
    // {
    //   path: '/contractTransaction',
    //   title: 'contractTransaction',
    //   component: () => import('@/views/preciousMetal/contractTransaction')
    // },
    // {
    //   path: '/positionList',//贵金属交割持仓
    //   title: '交割持仓',
    //   component: () => import('@/views/preciousMetal/positionList')
    // },
    // {
    //   path: '/leverTransactions',//贵金属永续持仓
    //   title: '永续合约',
    //   component: () => import('@/views/preciousMetal/leverTransactions')
    // },
    {
      path: '/currencyTrade',//币币交易
      title: '币币交易',
      component: () => import('@/views/currencyTrade/index')
    },
    {
      path: '/verificationCode',//接收验证码
      title: 'verificationCode',
      component: () => import('@/views/verificationCode')
    },
    {
      path: '/questionnaire',//调查问卷
      title: 'questionnaire',
      component: () => import('@/views/questionnaire')
    },
    {
      path: '/bps',//调查问卷
      title: 'bps',
      component: () => import('@/views/bps')
    },
    {
      path: '*',
      component: () => import('@/views/404')
    },
    {
      path: '/',
      component: () => import('@/views/index')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js